<template>
<div>
    <b-card>
        <template>
            <div class="container">
                <div class="row">
                    <div class="col-4 mb-3">
                        <label for="end-of-the-day-date-input"> {{ $t('endOfTheDay.date') }} </label>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('endOfTheDay.date')" size="sm" v-model="date" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')"  @input="accountingTransactionTypeListForEndOdDay()"/>
                    </div>
                    <b-col class="col-md-8 custom-search d-flex justify-content-end mt-2">
                        <div class="d-flex align-items-center">
                            <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="transfer()">{{ $t('endOfTheDay.transfer') }}</b-button>
                        </div>
                    </b-col>
                </div>
                <div class="row">
                    <!-- Türkiye Listesi -->
                    <div class="col-md-6">
                        <h4>{{ $t('endOfTheDay.turkey') }}</h4>
                        <table class="table">
                            <tbody>
                                <tr v-for="(item, index) in turkiyeList" :key="index">
                                    <td>{{ item.code }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>
                                        <b-form-checkbox v-model="item.checked"></b-form-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </b-card>
</div>
</template>

<script>
export default {
    data() {
        return {
            date: new Date().toISOString().slice(0, 10),
            turkiyeList: [],
        }
    },
    mounted() {
        this.accountingTransactionTypeListForEndOdDay()
    },
    methods: {
        accountingTransactionTypeListForEndOdDay(){

            const data = {
                requestDate: this.date
            }

            const controller = {
                name: 'AccountingTransaction',
                actionName: 'GetAccountingTransactionTypeListForEndOdDay'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.turkiyeList = response.data.turkiyeList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        transfer() {
            const data = {
                turkiyeList: this.turkiyeList,
                date: this.date,
                employeeId: localStorage.getItem('EmployeeId')
            }
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'transferEndOfDay'
            }
            const payload = {
                data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
    }
}
</script>

<style scoped>
.table td {
    vertical-align: middle;
}
</style>
